export const zendeskHistory = {
	page: {
		title: "My tickets",
		subtitle: "Track the status and replies for the tickets you have opened.",
	},
	filters: {
		placePlaceholder: "Filter by place",
		statusPlaceholder: "Filter by status",
		searchPlaceholder: "Search by subject or ID",
	},
	table: {
		columns: {
			createdAt: "Created at",
			id: "ID",
			subject: "Subject",
			placeName: "Place",
			updatedAt: "Last update",
			status: "Status",
		},
		viewDetails: "View details",
	},
	pagination: {
		pageSizeLabel: "Results per page",
	},
	emptyState: {
		noData: {
			title: "No tickets found",
			description:
				"You haven't opened any tickets yet. When you need support, open a ticket and follow it here.",
		},
		noFilters: {
			title: "No tickets match the selected filters",
			description:
				"Try adjusting the search, place, status or period to find what you're looking for.",
		},
	},
	status: {
		open: "Open",
		ongoing: "In progress",
		closed: "Resolved",
	},
	detail: {
		title: "Ticket details",
		loading: "Loading ticket details...",
		createdAt: "Created on {{date}}",
		closedAt: "Ticket closed on {{date}}",
		downloadAttachment: "Download attachment",
		requesterLabel: "You",
	},
};
